module.exports = __webpack_public_path__ + "src/assets/images/volums/eco2/volum_circle4.png?3de52c6da29ebf072e24e750a7e2beaf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/eco2/volum_circle4.png
// module id = 712
// module chunks = 0